import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const AddPrescription = () => {
  const [formData, setFormData] = useState({
    patientName: "",
    medicineName: "",
    dose: "",
    frequency: "",
    quantity: "",
    howToTake: "",
  });

  const [prescriptions, setPrescriptions] = useState([]);

  const handleONChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleONSave = () => {
    // Add the current form data to the prescriptions list
    setPrescriptions((prev) => [...prev, formData]);

    // Optionally reset form data after saving
    setFormData({
      patientName: "",
      medicineName: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
    });
  };

  const handleDiscard = () => {
    console.log("Discard clicked");
    setFormData({
      patientName: "",
      medicineName: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
    });
    setPrescriptions([]);
  };

  const handleDelete = (id) => {
    setPrescriptions((prev) => prev.filter((prescription) => prescription.id !== id));
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-xl-6">
                <label className="form-label fw-semibold mb-1">Patient Name</label>
                <input
                  type="text"
                  name="patientName"
                  value={formData.patientName}
                  onChange={handleONChange}
                  className="form-control form-control-sm"
                  placeholder="Enter Name"
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-xl-3 d-flex flex-column">
                <label className="form-label fw-semibold mb-1">Medicine Name</label>
                <input
                  type="text"
                  name="medicineName"
                  value={formData.medicineName}
                  onChange={handleONChange}
                  className="form-control form-control-sm"
                  placeholder="e.g. Paracetamol"
                />
              </div>

              <div className="col-xl-1 d-flex flex-column">
                <label className="form-label fw-semibold mb-1">Dose</label>
                <input
                  type="text"
                  name="dose"
                  value={formData.dose}
                  onChange={handleONChange}
                  className="form-control form-control-sm"
                  placeholder="e.g. 500mg"
                />
              </div>

              <div className="col-xl-2 d-flex flex-column">
                <label className="form-label fw-semibold mb-1">Frequency</label>
                <textarea
                  name="frequency"
                  value={formData.frequency}
                  onChange={handleONChange}
                  className="form-control form-control-sm"
                  placeholder="e.g. Twice a day"
                  rows="2"
                />
              </div>

              <div className="col-xl-2 d-flex flex-column">
                <label className="form-label fw-semibold mb-1">Quantity</label>
                <input
                  type="text"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleONChange}
                  className="form-control form-control-sm"
                  placeholder="e.g. 10"
                />
              </div>

              <div className="col-xl-4 d-flex flex-column">
                <label className="form-label fw-semibold mb-1">How to Take?</label>
                <textarea
                  name="howToTake"
                  value={formData.howToTake}
                  onChange={handleONChange}
                  className="form-control form-control-sm"
                  placeholder="e.g. After meals"
                  rows="2"
                />
              </div>
            </div>

            <div className="text-end">
              <button
                className="btn btn-success btn-sm me-2"
                onClick={handleONSave}
              >
                Save
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={handleDiscard}
              >
                Discard
              </button>
            </div>
            <div className="mt-4">
  {prescriptions.length > 0 ? (
    <>
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th>Medicine Name</th>
            <th>Dose</th>
            <th>Frequency</th>
            <th>Quantity</th>
            <th>How to Take?</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {prescriptions.map((prescription) => (
            <tr key={prescription.id}>
              <td>{prescription.medicineName}</td>
              <td>{prescription.dose}</td>
              <td>{prescription.frequency}</td>
              <td>{prescription.quantity}</td>
              <td>{prescription.howToTake}</td>
              <td>
                <Link className="edit me-3" aria-label="Edit">
                  <i className="fa fa-pencil-alt fs-18 text-success"></i>
                </Link>
                <Link
                  className="delete"
                  aria-label="Delete"
                  onClick={() => handleDelete(prescription.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <i className="fa fa-trash fs-18 text-danger"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-end mt-3">
        <button className="btn btn-primary">
          Generate Prescription
        </button>
      </div>
    </>
  ) : (
    <p></p>
  )}
</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPrescription;